import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const AccessNoneIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M 53.799127,52.141679 3.8583212,2.2008734 0,6.0320233 6.1678797,12.199903 c -2.852984,4.293062 -4.5104319,9.428433 -4.5104319,14.971373 0,14.998544 12.1727322,27.171276 27.1712762,27.171276 5.54294,0 10.678311,-1.657448 14.971373,-4.510432 L 49.967977,56 Z M 24.997574,39.670063 13.476953,28.149442 l 3.83115,-3.83115 7.689471,7.689471 0.489083,-0.489083 3.83115,3.83115 z M 33.148957,23.802038 13.857351,4.5104318 C 18.150412,1.6574478 23.285784,0 28.828724,0 43.827268,0 56,12.172732 56,27.171276 c 0,5.54294 -1.657448,10.678312 -4.510432,14.971373 L 36.980107,27.633188 44.180495,20.4328 40.349345,16.60165 Z" />
    </SvgIcon>
  );
};

export default AccessNoneIcon;
